import React, { useEffect, useState } from "react";
import { Route, Redirect, Switch } from "react-router-dom";

import asyncRoute from "../../helpers/hoc/asyncRoute";
import routes from "../../routes";

import { checkPermission, PrivateRoute } from "../../utils/route-auth";
import { MODULE_PERMISSIONS } from "../../constants/permission";

// const Apr = asyncRoute(() => import('./Apr'));
// const Hierarchy = asyncRoute(() => import('./Hierarchy'));
// const TaxonomyManager = asyncRoute(() => import('./TaxonomyManager'));
// const DataCapture = asyncRoute(() => import('./DataCapture'))
// const AudienceHierarchy = asyncRoute(() => import('./AudienceHierarchy'))
const CustomAudience = asyncRoute(() => import("./CustomAudience"));

const permissionArray = [
  // MODULE_PERMISSIONS.AUDIENCE_HIERARCHY,
  // MODULE_PERMISSIONS.AUDIENCE_HIERARCHYMANAGER,
  // MODULE_PERMISSIONS.AUDIENCE_APR,
  // MODULE_PERMISSIONS.AUDIENCE_TAXONOMYMANAGER,
  // MODULE_PERMISSIONS.AUDIENCE_DATACAPTURE,
  MODULE_PERMISSIONS.CUSTOM_AUDIENCE
];

const Audience = (props) => {
  const [paths, setPaths] = useState("");

  useEffect(() => {
    checkPathPermissions();
  }, [props.location.pathname]);

  const checkPathPermissions = () => {
    let availablePermissions = permissionArray.map((item) => checkPermission({ permissions: item })).filter((item) => item !== undefined);
    if (availablePermissions.length > 0) {
        let defaultPathArr = availablePermissions[0].split('::');
        let path = defaultPathArr[defaultPathArr.length - 1].trim().toLowerCase().replaceAll(' ', '-');
        setPaths(path);
    } else {
        setPaths('not-authorize');
    }
  };

  return (
    <Switch>
      <Route
        exact
        path={`${props.match.path}`}
        render={() => (
          <Redirect
            to={`${props.match.path}/${routes.audience.customAudience.name}`}
          />
        )}
      />
      <PrivateRoute
        path={`${props.match.path}/${routes.audience.customAudience.name}`}
        component={CustomAudience}
        permissions={MODULE_PERMISSIONS.CUSTOM_AUDIENCE}
        defaultRoute={`/${routes.containers.audience}/${paths}`}
      />

      {/* <PrivateRoute path={`${props.match.path}/${routes.audience.audienceHierarchy.name}`} component={AudienceHierarchy}
            permissions={MODULE_PERMISSIONS.AUDIENCE_HIERARCHY}
            defaultRoute={`/${routes.containers.audience}/${paths}`} />
        <PrivateRoute path={`${props.match.path}/${routes.audience.hierarchyManager.name}`} component={Hierarchy}
            permissions={MODULE_PERMISSIONS.AUDIENCE_HIERARCHYMANAGER}
            defaultRoute={`/${routes.containers.audience}/${paths}`} />
        <PrivateRoute path={`${props.match.path}/${routes.audience.taxonomyManager.name}`} component={TaxonomyManager}
            permissions={MODULE_PERMISSIONS.AUDIENCE_TAXONOMYMANAGER}
            defaultRoute={`/${routes.containers.audience}/${paths}`} />
        <PrivateRoute path={`${props.match.path}/${routes.audience.dataCapture.name}`} component={DataCapture}
            permissions={MODULE_PERMISSIONS.AUDIENCE_DATACAPTURE}
            defaultRoute={`/${routes.containers.audience}/${paths}`} /> */}
    </Switch>
  );
};

export default Audience;
